import useWebSocket, { ReadyState } from "react-use-websocket";
import { useEffect, useState } from "react";
import Requester from "../helpers/Requester";
import { useBinanceState } from "../contexts/BinanceContext";

export function useBinanceTrade() {
  const [listenKey, setListenKey] = useState<string | null>(null);


  const { updateBalances, updateOpenTrades, updateTrades } = useBinanceState();

  const wsUrl = `wss://stream.binance.com:9443/ws/${listenKey}`;

  const { lastMessage, readyState } = useWebSocket(wsUrl, {
    shouldReconnect: () => true, // автопереподключение
    reconnectAttempts: Infinity,
    reconnectInterval: 1000,
  });

  useEffect(() => {
    const requester = new Requester();

    if (readyState !== ReadyState.OPEN || !listenKey) {
      requester.get(requester.getUrl('api/listen-key')).then(response => {
        setListenKey(response.listenKey);
      }).catch(error => {
        console.error("Failed to fetch listen key", error);
      });
    }

  }, [readyState, listenKey]);

  useEffect(() => {
    if (lastMessage !== null) {
      try {
        const msg = JSON.parse(lastMessage.data);
        const data = msg.data ?? msg; // для ws и stream-mode

        updateBalances();
        updateOpenTrades();
        updateTrades();
      } catch (e) {
        console.error("Parse error", e);
      }
    }
  }, [lastMessage]);


  return {
  };
}